import { Link } from 'react-router-dom';
import { hotRecommendations } from '@/mocks/homeData';

export default function HotRecommendations() {
  return (
    <section className="py-16 md:py-20 bg-background-950" aria-labelledby="hot-title">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-10">
            <div>
              <span className="inline-block px-3 py-1 rounded-full border border-primary-500/40 text-primary-400 text-xs font-medium mb-3">
                热门推荐
              </span>
              <h2 id="hot-title" className="font-heading text-3xl md:text-4xl text-background-50">
                全网最热 · 万人追更
              </h2>
            </div>
            <Link
              to="/category/ranking"
              className="inline-flex items-center gap-1.5 text-background-400 hover:text-background-200 text-sm whitespace-nowrap transition-colors cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {hotRecommendations.map((item) => (
              <Link
                key={item.id}
                to={`/manhua/${item.id}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-800">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium">
                    {item.rating}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                    <p className="text-background-200 text-xs">{item.latestChapter}</p>
                  </div>
                </div>
                <h3 className="text-background-100 text-sm font-medium truncate group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-background-500 text-xs mt-1">{item.genre}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}